// extracted by mini-css-extract-plugin
module.exports = {"rankwarp":"styles_rankwarp__1Kcr0","rank":"styles_rank__3jXFw","label":"styles_label__2Dy1M","rectangle":"styles_rectangle__31YwB"};